import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectChannelBadges } from '../../../redux/selectors/notifications';
import * as CollaborationUserUI from './CollaborationUserUI';
import { useAppSelector } from '../../../redux/hooks';
import { workspacePropertySelector } from '../../../redux/selectors/workspace';
interface IProps {
  isSelected: boolean;
  userImageSrc: string;
  channelId: string;
  onClickCallback: (stringParam: string) => void;
  isMainAvatar?: boolean;
}

export default memo(function CollaborationUser({
  isSelected,
  userImageSrc,
  channelId,
  onClickCallback,
  isMainAvatar,
}: IProps) {
  const workspaceId = useAppSelector((state) =>
    workspacePropertySelector(state, 'id'),
  );
  const selectChannelBadgesMemo = useMemo(selectChannelBadges, []);
  const badgesCount = useSelector((state) =>
    selectChannelBadgesMemo(state, workspaceId, channelId),
  );

  const onClick = () => onClickCallback(channelId);

  return (
    <CollaborationUserUI.ChannelAvatar
      isMainAvatar={isMainAvatar}
      isSelected={isSelected}
      onClick={onClick}
    >
      {/* if badge is 0, do not display badge container */}
      {badgesCount && (
        <CollaborationUserUI.BadgeContainer>
          {badgesCount}
        </CollaborationUserUI.BadgeContainer>
      )}

      <CollaborationUserUI.AvatarImage src={userImageSrc} circular />
    </CollaborationUserUI.ChannelAvatar>
  );
});
